import { DateProps } from '../types/initData';

// ### Function accepts DateProps and returns string formated date (DD.MM.YYYY)
export const formatDate = (date: DateProps) => {
    if (date) {
        return `${date.split('-').reverse().join('.')}`;
    }
    return '';
};
